import { render } from "./CommonSearchComponent.vue?vue&type=template&id=1d1e31c1&ts=true"
import script from "./CommonSearchComponent.vue?vue&type=script&lang=ts"
export * from "./CommonSearchComponent.vue?vue&type=script&lang=ts"

import "./CommonSearchComponent.vue?vue&type=style&index=0&id=1d1e31c1&lang=css"

import exportComponent from "D:\\ventla-admin\\node_modules\\@vue\\cli-service\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__